// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "skeleton-2lYgC";
var _3 = "skeleton-shimmer-3N2Jy";
export { _1 as "__esModule", _2 as "skeleton", _3 as "skeleton-shimmer" }
export default { "__esModule": _1, "skeleton": _2, "skeleton-shimmer": _3 }
